<script setup>
import { defineProps, defineEmits } from "vue";
import IconSupportSuccess from "@/components/Icons/IconSupportSuccess.vue";
import IconSupportError from "@/components/Icons/IconSupportError.vue";
import { SUPPORT_STATUS } from "./constants";
import { t } from "@/controllerLK/AvalLocalization";

const props = defineProps({
  status: {
    type: [String, null],
    required: true,
    validator: (value) => [SUPPORT_STATUS.SUCCESS, SUPPORT_STATUS.ERROR].includes(value)
  }
});

const emit = defineEmits(["retry"]);

const isSuccess = () => props.status === SUPPORT_STATUS.SUCCESS;
const isError = () => props.status === SUPPORT_STATUS.ERROR;
</script>

<template>
  <div
    class="support-status"
    :class="{
      'support-status--success': isSuccess(),
      'support-status--error': isError()
    }"
  >
    <div class="support-status__content">
      <!-- Иконка -->
      <IconSupportSuccess
        v-if="isSuccess()"
        class="support-status__icon"
      />
      <IconSupportError
        v-else-if="isError()"
        class="support-status__icon"
      />

      <!-- Текст -->
      <div class="support-status__text">
        <h4 class="support-status__title">
          {{ isSuccess() ?
            t('support_widget.status.success.title') : t('support_widget.status.error.title') }}
        </h4>
        <p class="support-status__description">
          {{ isSuccess() ?
            t('support_widget.status.success.description') : t('support_widget.status.error.description') }}
        </p>
      </div>
    </div>
    <AvalButtonAccentPrimary
      type="submit"
      size="large"
      @click="emit('retry')"
    >
      {{ t('support_widget.button.retry') }}
    </AvalButtonAccentPrimary>
  </div>
</template>

<style scoped lang="scss">
.support-status {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding: 10px 14px;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin-top: 123px;
  }

  &__icon {
    width: 80px;
    height: 80px;
  }

  &__text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
    padding: 0 14px;
  }

  &__title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: var(--text-text-main);
  }

  &__description {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--text-text-main);
  }
}
</style>